<template>
	<div class="auth-form unsubscribe-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ 'main/unsubscribe' | ftc }}</h4>

		<div class="w5-field text-center alert alert-success margin-20-0" v-show="successMessage !== false">
			<p style="margin: 0; padding: 10px;" v-withSafeTags="localeFtc(successMessage)"></p>
		</div>

		<div class="w5-field text-center alert alert-danger margin-20-0" v-show="errorMessage !== false">
			<p style="margin: 0; padding: 10px;" v-withSafeTags="localeFtc(errorMessage)"></p>
		</div>

		<template v-if="showQuestion === false">
			<!-- ссылка на главную -->
			<br>
			<div class="text-left code-link">{{ 'login/return_to_main_page1' | ftc }} <a href="/" :title="'login/return_to_main_page2' | ftc">{{ 'login/return_to_main_page2' | ftc }}</a></div>
		</template>

		<template v-else>
			<div class="w5-field text-left margin-20-0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="localeFtc('main/unsubscribe_question')"></p>
				<p style="margin: 0; padding: 10px;" v-withSafeTags="localeFtc('main/unsubscribe_text')"></p>
				<br><br>
				<div style="line-height: 50px;">
					<a class="pull-left" href="/" :title="'login/return_to_main_page2' | ftc">{{ 'login/return_to_main_page2' | ftc }}</a>
					<span class="btn btn-submit pull-right" @click.stop="unsubscribeStart">{{ 'main/unsubscribe_button' | ftc }}</span>
				</div>
			</div>
		</template>
	</div>		
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'unsubscribeForm',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			successMessage: false,
			errorMessage: false,
			isCode: null,
			isType: null,
			showQuestion: false
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		// должен быть задан тип и код
		let { type: _type, code: _code } = this.$route.params

		// проверка корректности
		if (_type === undefined || _type === null || String(_type).trim() === '' ||
			_code === undefined || _code === null || String(_code).trim() === '' || String(_code).length !== 32)
		{
			this.errorMessage = 'main/unsubscribe_error'
			return
		}

		// запоминаем
		this.isType = _type
		this.isCode = _code
		// покажем вопрос
		this.showQuestion = true
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		unsubscribeStart() {
			// сразу прячем вопрос
			this.showQuestion = false
			// готовим URL
			let _url = this.APIServerUrl + '/ticket/unsubscribe/' + this.isType + '/' + this.isCode
			// запрос
			this.$http.get(_url).then(
				// успех
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// смотрим на ответ
					if (_dt && _dt['status'] === 'ok')
					{
						// покажем сообщени
						this.successMessage = 'main/unsubscribe_done'
						// на этом все
						return
					}

					// ошибка
					this.errorMessage = this.localeFtc('<b>main/error_desc</b>')
					if (_dt && _dt.content) this.errorMessage += '<br><br>' + _dt.content
					else this.errorMessage = this.errorMessage.replace(':', '.').replace(/strong/g, 'span')
				},
				// неудача
				res => {
					this.errorMessage = this.formatRequestError(res)
				}
			)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.unsubscribe-form {
	margin: auto !important;
	width: 50% !important;
	left: 25% !important;
}

@media (max-width: 767px) {
	.unsubscribe-form {
		width: 300px !important;
		left: 50% !important;
		margin-left: -150px !important;

	}
}
</style>



// WEBPACK FOOTER //
// Unsubscribe.vue?2b5b864c